export enum DocumentType {
  Client = "ClientData",
  Opportunity = "OpportunityData",
  ExistingPolicyLife = "ExistingPolicyLife",
  ExistingPolicyAnnuity = "ExistingPolicyAnnuity",
  OpportunityAttachement = "OpportunityAttachmentData",
}
